export default __webpack_public_path__ + "media/background.1270f.png";